import React from 'react';

const Operations = () => {
  return (
    <div className="sidebar-icon">
      <svg
        className="sidebar-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 3H10V10H3V3Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M14 3H21V10H14V3Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M3 14H10V21H3V14Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
        <path
          d="M14 14H21V21H14V14Z"
          style={{ strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }}
        />
      </svg>
    </div>
  );
};

export default Operations;
